import { combineReducers } from "redux";
import { assetAcceptance } from "./assetAcceptanceReducer";


const authReducers = combineReducers({
  assetAcceptance,
});

export default authReducers;
